import { GridItemState } from '@/store/slices/layout-grid/types';

const rules = new Set<string>();
const snapshots = new Map<string, GridItemState>();

export const addRule = (matcher: string): void => {
  rules.add(matcher);
};

export const getRules = (): ReadonlySet<string> => rules;

export const setSnapshot = (matcher: string, value: GridItemState): void => {
  snapshots.set(matcher, value);
};

export const getSnapshot = (matcher: string): GridItemState | undefined => snapshots.get(matcher);

export const clearSnapshot = (matcher: string): void => {
  snapshots.delete(matcher);
};

export const isInRegion = (pathname: string, matcher: string): boolean => pathname.includes(matcher);
